import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import classNames from "classnames";

import { styles } from "./mark.styles";

export type MarkColor =
  | "red"
  | "orange"
  | "green"
  | "turquoise"
  | "cyan"
  | "blue"
  | "violet"
  | "purple"
  | "tan"
  | "black";

export type MarkVariant =
  | "highlight-light"
  | "highlight"
  | "highlight-dark"
  | "text";

@customElement("bp-mark")
export class Mark extends LitElement {
  static styles = styles;

  @property()
  color?: MarkColor = "orange";

  @property()
  variant?: MarkVariant = "highlight";

  @property({ type: Boolean, attribute: "can-spotlight" })
  canSpotlight?: boolean;

  render() {
    const classes = classNames(this.color, this.variant, {
      "can-spotlight": this.canSpotlight,
    });
    return html`<mark class="${classes}"><slot></slot></mark>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-mark": Mark;
  }
}
